import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import {
  ReportTemplateFileRequest,
  TermsOfUseFilterRequest,
  TermsOfUseGetDetailsRequest,
  TermsOfUseSaveRequest
} from '@/main/models/request';
import {
  GetFileResponse,
  TermsOfUseDetailsResponse,
  TermsOfUseResponse
} from '@/main/models/response';
import { FileTypeEnum } from '@/main/services/enum/FileTypeEnum';
import { AxiosResponse } from 'axios';

export abstract class IFileImportApi {
  abstract getFile(
    typeFile: FileTypeEnum
  ): Promise<AxiosResponse<Result<GetFileResponse>>>;

  abstract getFileReportTemplate(
    request: ReportTemplateFileRequest
  ): Promise<AxiosResponse<Result<GetFileResponse>>>;
  abstract searchGridTerm(
    request: TermsOfUseFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<TermsOfUseResponse>>>;

  abstract saveTerm(
    request: TermsOfUseSaveRequest,
    file: File,
    sendFile: boolean
  ): Promise<AxiosResponse<Result<unknown>>>;

  abstract getDetailsTerm(
    request: TermsOfUseGetDetailsRequest
  ): Promise<AxiosResponse<Result<TermsOfUseDetailsResponse>>>;

  abstract getFileImport(
    fileImportGuid: string
  ): Promise<AxiosResponse<Result<string>>>;
}
